const footerDefaults = {
  footer_brand: "Cap Rate Experts",
  footer_description:
    "Investor-focused advisory and brokerage support for NNN and Absolute NNN acquisitions across the United States, including high CAP investment opportunities and 1031 exchange solutions.",
  footer_copyright: "© 2026 American Realty Network LLC. All rights reserved.",
};

function Footer({ onNavigate, siteSettings = footerDefaults }) {
  const settings = { ...footerDefaults, ...(siteSettings || {}) };

  return (
    <footer className="mt-20 border-t border-obsidian-200 bg-obsidian-950 text-cream-50">
      <div className="section-wrap py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <p className="font-serif text-3xl">{settings.footer_brand}</p>
            <p className="mt-4 max-w-xl text-sm leading-7 text-cream-100/85">
              {settings.footer_description}
            </p>
          </div>

          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-cream-100/70">Explore</p>
            <div className="mt-4 flex flex-col gap-2 text-sm">
              <button className="text-left hover:text-cream-200" onClick={() => onNavigate("/properties")}>
                Properties
              </button>
              <button className="text-left hover:text-cream-200" onClick={() => onNavigate("/services")}>
                Services
              </button>
              <button className="text-left hover:text-cream-200" onClick={() => onNavigate("/about")}>
                About Us
              </button>
              <button className="text-left hover:text-cream-200" onClick={() => onNavigate("/faq")}>
                Insights / FAQ
              </button>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-cream-100/70">Investor Desk</p>
            <div className="mt-4 flex flex-col gap-2 text-sm">
              <button
                className="rounded-xl border border-cream-100/20 px-3 py-2 text-left hover:bg-cream-100/10"
                onClick={() => onNavigate("/questionnaire")}
              >
                Questionnaire
              </button>
              <button
                className="rounded-xl border border-cream-100/20 px-3 py-2 text-left hover:bg-cream-100/10"
                onClick={() => onNavigate("/eric-nur")}
              >
                Eric Nur
              </button>
              <button
                className="rounded-xl border border-cream-100/20 px-3 py-2 text-left hover:bg-cream-100/10"
                onClick={() => onNavigate("/contact")}
              >
                Request Deal Package
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-cream-100/20 pt-6 text-xs uppercase tracking-[0.15em] text-cream-100/70">
          {settings.footer_copyright}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
